import { v4 } from "uuid"

export const generateUUID = () => {
	return v4()
}

export const generateIntegerID = () => {
	return Date.now()
}
